import axios from "axios";
import config from "./config";

const BASE_URL = config.baseApi;

const customAxios = axios.create({
  baseURL: BASE_URL,
});

const requestHandler = (request) => {
  const userData = localStorage.getItem("twinbox-admin-store");
  const user = JSON.parse(userData);

  if (user) {
    const token = user.token;
    request.headers.Authorization = `${token}`;
  }
  return request;
};

const responseHandler = (response) => {
  // Only an auth failure (401) ends the session. A 404 is just "not found" and must NOT log the
  // admin out. (This success-path check is effectively dead since axios rejects non-2xx, but keep
  // it correct.)
  if (response.status === 401) {
    localStorage.clear();
    window.location.assign("/login");
  }
  return response;
};

const requestErrorHandler = (error) => {
  return Promise.reject(error);
};

const responseErrorHandler = (error) => {
  if (error.response) {
    // Log out ONLY on 401 (expired/invalid token). A 404 from any endpoint must not nuke the
    // session (that was forcing a logout on every not-found response).
    if (error.response.status === 401) {
      localStorage.clear();
      window.location.assign("/login");
      return Promise.reject(error);
    }
  }
  return Promise.reject(error);
};

customAxios.interceptors.request.use(
  (request) => requestHandler(request),
  (error) => requestErrorHandler(error)
);

customAxios.interceptors.response.use(
  (response) => responseHandler(response),
  responseErrorHandler
);

export default customAxios;
